export class UsuarioModel {
    id: string;
    nome: string;
    email: string;
    cargo: string;
    nivel: number;
    documento: string;
    foto: string;
    primeiroAcesso: boolean = true;
    resetarSenha: string;
    token: string;
} 


export class LogAcoesModel {
    idLoja: string; 
    idUsuario: string; 
    acao: string; 
    dados: string; 
    dispositivo: string;
}

export class ClienteModel {
    documento: any;
}




// WEBPACK FOOTER //
// ./src/app/models/UsuarioModel.ts